const ddmmyy = (s) => { const [y, m, d] = s.split("-"); return `${d}/${m}/${y.slice(2)}`; };
const cell = "border border-[#d9d9d9] px-2 py-1";

const Block = ({ group, rows, date }) => (
  <>
    <tr className="bg-[#ffff00] h-8"><td className={cell} /><td className={cell} /><td className={cell} /></tr>
    <tr>
      <td className={`${cell} bg-[#fce5cd] font-bold uppercase text-[17px]`}>{group.name}</td>
      <td className={`${cell} bg-[#fce5cd]`} />
      <td className={`${cell} bg-[#d9ead3] font-bold text-center text-[17px]`}>{ddmmyy(date)}</td>
    </tr>
    {rows.map((e) => (
      <tr key={e.id}>
        <td className={`${cell} text-[#1155cc] underline`}>{e.site_name}</td>
        <td className={cell}>{e.user_code}</td>
        <td className={`${cell} text-right`}>{Number(e.amount).toLocaleString("en-IN", { maximumFractionDigits: 2 })}</td>
      </tr>
    ))}
  </>
);

export const ReportSheet = ({ blocks, date, innerRef }) => (
  <div ref={innerRef} data-testid="report-sheet" className="bg-white p-3 inline-block" style={{ fontFamily: "Arial, sans-serif" }}>
    <table className="border-collapse text-[16px] text-black">
      <colgroup><col style={{ width: 230 }} /><col style={{ width: 200 }} /><col style={{ width: 150 }} /></colgroup>
      <tbody>{blocks.map((b) => <Block key={b.group.id} {...b} date={date} />)}</tbody>
    </table>
  </div>
);
